var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.maxCols !== null)?_c('RowColComp',{attrs:{"items":_vm.vidz,"apiErrorMessage":_vm.apiErrorMessage,"columns":_vm.maxCols,"lang":_vm.lang}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }